import { combineReducers } from 'redux'
import Auth from './Auth'
import Programs from './Programs'
import Layouts from './Layouts'

export default combineReducers({
  auth: Auth,
  programs: Programs,
  layouts: Layouts,
})
